const flexJustifyCenter = {
  "justifyContent": "center !important"
};

export { flexJustifyCenter };
